export const pageview = url => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return

  window.gtag('config', process.env.NEXT_PUBLIC_GA_ID_NEW, {
    page_path: url,
  })
}

export const event = ({ action, category, label, value }) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  })
}

export const eventConversion = () => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return

  window.gtag('event', 'conversion', {
    // send_to: 'AW-11248975563/Uy1KCPrDyLoYEMv99vMp',
    send_to: process.env.NEXT_PUBLIC_EVENT_CONVERSION_GARAGE,
  })
}
